import axios from "axios";
import { Message, Loading } from "element-ui";
// axios.defaults.baseURL = "http://106.15.199.41:8088";
// baseURL 由环境变量注入：开发环境为 /api（经 dev server 代理转发，避免跨域），
// 生产环境为线上后端地址（见 config/dev.env.js 与 config/prod.env.js）
axios.defaults.baseURL = process.env.API_BASE || "https://admin.kingcer.com";
axios.defaults.timeout = 20000;
axios.defaults.headers.post["Content-Type"] = "application/json;charset=utf-8";
const http = axios.create();

const post = http.post;
http.post = (url, params, options = {}, config = {}) => {
    const requestConfig = Object.assign({}, options, config);
    return post(url, params, requestConfig).then((data = {}) => {
        const body = data.data;
        if (body === undefined || body === null) {
            return Promise.resolve(false);
        }
        // 兼容 {code: 200, data: xxx} 包装结构
        if (
            typeof body === "object" &&
            !Array.isArray(body) &&
            body.code !== undefined
        ) {
            return Promise.resolve(body.data !== undefined ? body.data : false);
        }
        // 兼容裸数组 / 裸对象等无包装结构，直接返回原始数据
        return Promise.resolve(body);
    });
};

let loading;
function closeLoading() {
    if (loading && typeof loading.close === "function") {
        loading.close();
    }
}
// 请求拦截器
http.interceptors.request.use(
    config => {
        let info = window.localStorage.getItem("info");
        if (info) {
            config.headers.token = `${JSON.parse(info).token}`;
        }
        // 加载提示
        loading = Loading.service({
            lock: true,
            text: "数据加载中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.2)"
        });
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// 响应拦截器
http.interceptors.response.use(
    response => {
        const body = response.data;
        // 兼容后端直接返回数组/字符串等无 code 包装的数据（如 getBannerList 返回裸数组）
        const isWrapped =
            body !== null &&
            typeof body === "object" &&
            !Array.isArray(body) &&
            body.code !== undefined;
        if (!isWrapped) {
            // 无 code 包装：HTTP 2xx 即视为成功
            closeLoading();
            return response;
        }
        if (String(body.code) === "200") {
            // 成功
            closeLoading();
            return response;
        } else if (String(body.code) === "1004") {
            // token
            closeLoading();
            window.localStorage.clear();
            Message.error("登录过期,请重新登录");
            location.href = "/";
        } else {
            if (response.config.responseType === "blob") {
                closeLoading();
                return response;
            } else {
                closeLoading();
                Message.error(
                    body.msg ||
                    body.message ||
                    "数据加载失败，请刷新页面重试！"
                );
            }
        }
    },
    error => {
        closeLoading();
        Message.error("网络异常，请刷新页面重试！");
        return Promise.reject(error);
    }
);

export default http;




// WEBPACK FOOTER //
// ./src/api/index.js